import { PhoneNumber, parsePhoneNumberWithError } from 'libphonenumber-js'

import { captureError } from '@/app/service/util/error'
import { addPlusToPhoneNumber } from '@/app/service/util/format'

export const toPhoneNumber = (pn: string): PhoneNumber | undefined => {
  try {
    return parsePhoneNumberWithError(addPlusToPhoneNumber(pn))
  } catch (err) {
    captureError(err, {
      pn,
    })
    return undefined
  }
}
